module.exports = __webpack_public_path__ + "media/static/flags/it-85a8b98a34c1fb154abf1c063411c34c.svg";